import { useState } from 'react';

export default function Hero() {
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePhoneClick = () => {
    if (!showPhoneNumber) {
      setShowPhoneNumber(true);
    } else {
      window.location.href = 'tel:070-8453-9292';
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b9db82e61e190b9fea6e3b5a23c8b2a5.jpg"
          alt="日本刀と甲冑の背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-6 lg:px-12 py-32 text-center">
        <div className="max-w-5xl mx-auto space-y-8">
          <div className="inline-block bg-samurai-gold/20 backdrop-blur-sm border-2 border-samurai-gold px-5 py-2 rounded-full">
            <p className="text-samurai-gold font-bold text-base lg:text-lg whitespace-nowrap">
              全国対応・即日査定・高価買取保証
            </p>
          </div>

          <h2 className="text-4xl lg:text-6xl xl:text-7xl font-black text-white leading-tight font-serif">
            日本刀・甲冑・兜の<br />
            <span className="text-samurai-gold">出張買取専門店</span>
          </h2>

          <div className="hidden sm:grid grid-cols-2 gap-6 pt-12 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-6">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-samurai-gold rounded-full">
                <span className="text-4xl font-black text-white">¥</span>
              </div>
              <h3 className="text-white font-bold text-xl mb-2 whitespace-nowrap">海外バイヤーによる高価買取</h3>
              <p className="text-white/90 text-base">
                アメリカ・ヨーロッパ・中東のアンティークディーラーと連携し、海外相場での買取をしております円安の今がチャンス
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-6">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-map-pin-line text-5xl text-samurai-gold"></i>
              </div>
              <h3 className="text-white font-bold text-xl mb-2 whitespace-nowrap">全国対応</h3>
              <p className="text-white/90 text-base">
                日本全国どこでも無料で出張査定いたします
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
